import React from 'react';
import {AvForm} from 'availity-reactstrap-validation';
import TillConnectionService from "../../shared/service/TillConnectionService";
import TillConnectionColumn from "../../shared/component/dataTable/columns/TillConnectionColumn.json";
import DataTableAll from "../../shared/component/dataTable/DataTableAll";
import '../../shared/styles/SettingsPage.css';

export default class TillConnections extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tillConnectionList: []
        }

        this.tillConnectionService = new TillConnectionService();
    }

    componentDidMount() {
       this.refreshDataTable();
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        <div className="settings-page__header">
                            <h1 className="settings-page__title">Till Connections</h1>
                        </div>
                        <div className="settings-page__panel">
                            <div className="settings-page__table-wrap">
                                <DataTableAll
                                    ref={(elem) => this.refDataTable = elem}
                                    fields={TillConnectionColumn.fields}
                                    objectName={TillConnectionColumn.name}
                                    data={this.state.tillConnectionList}
                                    rows={10}
                                    paginator={true}
                                    selectionMode="single"
                                    loading={this.state.loading}/>
                            </div>
                        </div>
                    </div>
                </AvForm>
            </div>
        );
    }

    refreshDataTable = () => {
        this.tillConnectionService.findAll().then(response => this.setState({
            tillConnectionList: response
        }));
    }
}
